import type { v2, ImportAllConfigsParameters, ImportOverviewPageV2Parameters } from '@sap/ux-specification-types';
import { PageTypeV2, ManifestSection, SchemaType } from '@sap/ux-specification-types';
import { AppProvider } from '../../../common/appProvider';
import { transferSettingsOfObject } from '../common';
import { createOverviewPageConfig } from '../pages/overviewPage';
import { AppSettings } from '../../application';
import { getSchemaFilePath, generatePageId } from '../../../common';

export class V2OvpProvider extends AppProvider {
    /**
     *
     * @param importParameters - Parameters required for importing configurations, including manifest, schemas, and logger.
     */
    public constructor(importParameters: ImportAllConfigsParameters) {
        const pages: v2.Pages = {};
        const sapOvp = importParameters.manifest[ManifestSection.ovp];
        const appSettings = new AppSettings();
        const schemaFile = getSchemaFilePath(SchemaType.Application);
        transferSettingsOfObject(
            appSettings,
            importParameters.manifest,
            importParameters.appSchemas[schemaFile.filename]['definitions']['AppSettings'],
            undefined
        );
        const jsonSchema: string = Object.keys(importParameters.appSchemas).find((element) =>
            element.includes(PageTypeV2.OverviewPage)
        );
        const parameters: ImportOverviewPageV2Parameters = {
            manifest: importParameters.manifest,
            jsonSchema: importParameters.appSchemas[jsonSchema],
            logger: importParameters.logger
        };
        const page: v2.Page = {
            pageType: PageTypeV2.OverviewPage,
            config: createOverviewPageConfig(parameters),
            entitySet: sapOvp.globalFilterEntitySet
        };
        const id = generatePageId(page.pageType, page.entitySet);
        pages[id] = page;
        super(importParameters, id, pages, appSettings);
    }
}
